import { render, staticRenderFns } from "./HeaderCollapseSocial.vue?vue&type=template&id=6d1e9d99&"
import script from "./HeaderCollapseSocial.vue?vue&type=script&lang=js&"
export * from "./HeaderCollapseSocial.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollapseSocial.vue?vue&type=style&index=0&id=6d1e9d99&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports